var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_c('iframe',{staticClass:"CL_frame",attrs:{"id":"ml_presentation_iframe","src":_vm.url,"width":"100%","height":"100%","allow":"camera *;fullscreen","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }